import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import { getHttp , postHttp } from './http/http.js'
import "babel-polyfill"

Vue.prototype.$get = getHttp;
Vue.prototype.$post = postHttp;

Vue.use(ElementUI)

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js